export const footNotesSearchCriteria = [
   {
      screen: 'FOOTNOTES',
      config: [
         {
            sectionName: 'Data',
            sectionKey: 'data',
            sectionForm: 'radioButton',
            fields: [
               {
                  inputType: 'radioButton',
                  radioButtonOptions: [
                     { key: 'Filed', field: 'filed' },
                     {
                        key: 'Historical',
                        field: 'historical',
                     },
                     {
                        key: 'AVAILABLE',
                        field: 'available',
                     },
                  ],
               },
            ],
         },
         {
            sectionName: 'Record 2',
            sectionKey: 'record2s',
            fields: [
               {
                  field: 'fareTariffNumber',
                  key: 'TAR',
                  fullName: 'Fare Tariff Number',
                  validationName: 'NUMERIC',
                  characterLimit: 3,
                  dataType: 'number',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'carrier_code',
                  key: 'CXR',
                  fullName: 'Carrier Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: 'footnoteCode',
                  key: 'FT',
                  fullName: 'Footnote Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: 'categoryNumber',
                  key: 'CAT#',
                  fullName: 'Category Number',
                  validationName: 'NUMERIC',
                  characterLimit: 2,
                  dataType: 'number',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'categoryName',
                  key: 'CAT NM',
                  fullName: 'Category Name',
                  placeHolder: '',
                  inputType: 'multiSelect',
                  options: [
                     {
                        label: 'Travel',
                        value: '14',
                     },
                     {
                        label: 'Sales',
                        value: '15',
                     },
                     {
                        label: 'Seasons',
                        value: '03',
                     },
                     {
                        label: 'Blackout',
                        value: '11',
                     },
                  ],
                  validationName: 'ALPHA_NUMERIC',
               },
               {
                  field: 'sequenceNumber',
                  key: 'SEQUENCE',
                  fullName: 'Sequence Number',
                  validationName: 'NUMERIC',
                  characterLimit: 7,
                  dataType: 'number',
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'effectiveDateString',
                  key: 'EFF DT',
                  fullName: 'Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'discontinueDateString',
                  key: 'DISC DT',
                  fullName: 'Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'location1Type',
                  key: 'LOC1 TYPE',
                  fullName: 'Location 1 Type',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1',
                  fullName: 'Location 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: '1QW',
                  inputType: 'text',
               },
               {
                  field: 'location2Type',
                  key: 'LOC2 TYPE',
                  fullName: 'Location 2 Type',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2',
                  fullName: 'Location 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: '1QW',
                  inputType: 'text',
               },
               {
                  field: 'fareClassCode',
                  key: 'FBC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 8,
                  dataType: 'string',
                  placeHolder: 'A1B2C3DR',
                  inputType: 'text',
               },
               {
                  field: 'roundTripIndicator',
                  key: 'OWRT',
                  fullName: 'Round Trip Indicator',
                  validationName: 'NUMERIC',
                  characterLimit: 1,
                  dataType: 'number',
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'routingNumber',
                  key: 'RTG',
                  fullName: 'Routing Number',
                  validationName: 'NUMERIC',
                  characterLimit: 4,
                  dataType: 'number',
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'applicationInd',
                  key: 'NOTAPPL',
                  fullName: 'Application Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'jointCarrier997Id',
                  key: 'JT CXR TBL',
                  fullName: 'Joint Carrier 997 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'segmentCount',
                  key: 'SEGS',
                  fullName: 'Segment Count',
                  validationName: 'NUMERIC',
                  characterLimit: 3,
                  dataType: 'number',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'FARES',
                  fullName: 'Fare Count',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'actionCode',
                  key: 'ACT',
                  fullName: 'Action Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'batchCode',
                  key: 'BATCH CODE',
                  fullName: 'Batch Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'batchNumber',
                  key: 'BATCH NUMBER',
                  fullName: 'Batch Number',
                  validationName: 'NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: '12345',
                  inputType: 'text',
               },
               {
                  field: 'receivedDateString',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'product_type',
                  key: 'FT TYPE',
                  fullName: 'Footnote Type',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'S',
                  fullName: 'Footnote Status Code',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: '',
                  key: 'DIST GRP',
                  fullName: 'Distribution Group',
                  validationName: 'NUMERIC',
                  disabled: true,
                  characterLimit: 3,
                  dataType: 'number',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'changeDate',
                  key: 'CGH  DT',
                  fullName: 'Change Date',
                  validationName: 'DATE_STRING',
                  disabled: false,
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: '01/01/2015',
                  inputType: 'datePicker',
               },
               {
                  field: '',
                  key: 'CHG USER',
                  fullName: 'Change User',
                  validationName: 'ALPHA_NUMERIC',
                  disabled: true,
                  characterLimit: 3,
                  dataType: 'string',
                  placeHolder: '123',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: 'Record 2 Segments',
            sectionKey: 'record2Segments',
            fields: [
               {
                  field: 'relationalInd',
                  key: 'REL',
                  fullName: 'Relational Indicator',
                  validationName: 'SPECIAL_CHAR',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'inOutboundInd',
                  key: 'IO',
                  fullName: 'Inbound/Outbound Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'directionalInd',
                  key: 'DIR',
                  fullName: 'Directional Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'sectionNumber',
                  key: 'CAT#',
                  fullName: 'Category Number',
                  validationName: 'NUMERIC',
                  characterLimit: 2,
                  dataType: 'number',
                  placeHolder: '11',
                  inputType: 'text',
               },
               {
                  field: 'record3TableId',
                  key: 'REC3ID',
                  fullName: 'Record 3 Table ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'segmentNumber',
                  key: 'SEG',
                  fullName: 'Segment Number',
                  validationName: 'NUMERIC',
                  characterLimit: 100,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '03 - Seasons',
            sectionKey: 'record3s',
            categoryNumber1: '3',
            fields: [
               {
                  field: 'overrideInd',
                  key: 'OVR IND',
                  fullName: 'Override Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'seasonTypeCode',
                  key: 'SEA TYP',
                  fullName: 'Season Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'startDate',
                  key: 'SEA ST',
                  fullName: 'Season Start Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'stopDate',
                  key: 'SEA END',
                  fullName: 'Season End Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Date Override 994 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Travel Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Travel Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Reservation Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Reservation Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Location 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Location 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Travel Segment Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 ID',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Line Text',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'receivedDateString',
                  key: 'REC DT',
                  fullName: 'Transmission DateTime',
                  validationName: 'DATE_STRING',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'datePicker',
               },
            ],
         },
         {
            sectionName: '11 - Blackout',
            sectionKey: 'record3s',
            categoryNumber1: '11',
            fields: [
               {
                  field: 'applicationInd',
                  key: 'APP IND',
                  fullName: 'Application Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'intConnectionInd',
                  key: 'INT CON WV',
                  fullName: 'International Connection Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'startDate',
                  key: 'BLACKOUT ST',
                  fullName: 'Blackout Start Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'stopDate',
                  key: 'BLACKOUT END',
                  fullName: 'Blackout End Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Date Override 994 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Travel Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Travel Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Reservation Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Reservation Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'andTable995Id',
                  key: 'AND GEO 995',
                  fullName: 'And Geographic 995 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'andLocationType',
                  key: 'AND LOCTYP 995',
                  fullName: 'And Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'andLocation1Code',
                  key: 'AND LOC1 995',
                  fullName: 'And Location 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'andLocation2Code',
                  key: 'AND LOC2 995',
                  fullName: 'And Location 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'andTravelSegmentIndicator',
                  key: 'AND TSI 995',
                  fullName: 'And Travel Segment Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: 'betweenTable995Id',
                  key: 'BET GEO 995',
                  fullName: 'Between Geographic 995 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'betweenLocationType',
                  key: 'BET LOCTYP 995',
                  fullName: 'Between Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'betweenLocation1Code',
                  key: 'BET LOC1 995',
                  fullName: 'Between Location 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'betweenLocation2Code',
                  key: 'BET LOC2 995',
                  fullName: 'Between Location 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: '1234Q',
                  inputType: 'text',
               },
               {
                  field: 'betweenTravelSegmentIndicator',
                  key: 'BET TSI 995',
                  fullName: 'Between Travel Segment Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1Q',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 ID',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Line Text',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'receivedDateString',
                  key: 'REC DT',
                  fullName: 'Transmission DateTime',
                  validationName: 'DATE_STRING',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '14 - Travel Restrictions',
            sectionKey: 'record3s',
            categoryNumber1: '14',
            fields: [
               {
                  field: 'commenceFromDate',
                  key: 'TVL ST',
                  fullName: 'Commence From Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'commenceToDate',
                  key: 'TVL END',
                  fullName: 'Commence To Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'completeDate',
                  key: 'TVL CMPLT',
                  fullName: 'Complete Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'completeInd',
                  key: 'RI',
                  fullName: 'Complete Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Date Override 994 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Travel Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2Ce',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Travel Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Reservation Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Reservation Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Location 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Location 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Travel Segment Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 2,
                  dataType: 'string',
                  placeHolder: '1q',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 ID',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Line Text',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'timeOfDay',
                  key: 'RET TM',
                  fullName: 'Time of Day',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 4,
                  dataType: 'string',
                  placeHolder: '123q',
                  inputType: 'text',
               },
               {
                  field: 'receivedDateString',
                  key: 'REC DT',
                  fullName: 'Transmission DateTime',
                  validationName: 'DATE_STRING',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'Q',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '15 - Sales Restrictions',
            sectionKey: 'record3s',
            categoryNumber1: '15',
            fields: [
               {
                  field: 'ticketingFromDate',
                  key: 'FST TKT',
                  fullName: 'Ticketing From Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'ticketingToDate',
                  key: 'LST TKT',
                  fullName: 'Ticketing To Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationFromDate',
                  key: 'FST RES',
                  fullName: 'Reservation From Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationToDate',
                  key: 'LST RES',
                  fullName: 'Reservation To Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Date Override 994 ID',
                  validationName: 'NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Travel Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Travel Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Reservation Effective Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Reservation Discontinue Date',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'cat15SegLocationTypeCode',
                  key: 'LOCTYP 995',
                  fullName: 'Category 15 Segment Location Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'q',
                  inputType: 'text',
               },
               {
                  field: 'cat15SegLocation1Code',
                  key: 'LOC1 995',
                  fullName: 'Category 15 Segment Location 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'cat15SegLocation2Code',
                  key: 'LOC2 995',
                  fullName: 'Category 15 Segment Location 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 ID',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 8,
                  dataType: 'number',
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Line Text',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 1,
                  dataType: 'string',
                  placeHolder: 'q',
                  inputType: 'text',
               },
               {
                  field: 'receivedDateString',
                  key: 'REC DT',
                  fullName: 'Transmission DateTime',
                  validationName: 'DATE_STRING',
                  characterLimit: 100,
                  dataType: 'string',
                  placeHolder: '',
                  inputType: 'text',
               },
            ],
         },
      ],
   },
];

export default footNotesSearchCriteria;
